import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import mm from './locales/mm.json';
import jp from './locales/jp.json';

Vue.use(VueI18n);

const messages = {
  en,
  mm,
  jp,
};

const savedLocale = localStorage.getItem('locale') || 'en';

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages,
});

export default i18n;